<h6>{{ serialNumber }}</h6>

<!--<div class="container">-->
<!--  <button class="btn btn-primary btn-block mb-5" type="button" (click)="connectToReader()">Connect To Reader</button>-->
<!--</div>-->
<!--<div class="container">-->
<!--  <button class="btn btn-primary btn-block mb-5" type="button" (click)="processPayment()">Process Payment</button>-->
<!--</div>-->
<!--<div class="container">-->
<!--  <button class="btn btn-primary btn-block mb-5" type="button" (click)="showSettings()">Show Settings</button>-->
<!--</div>-->
<div class="container mt-3 mb-3">
  <img class="img-fluid" src="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/06WjvcTlzU3D0YqaJPxF/media/68dbd346877167039a4f0415.png"/>
  <h3 class="text-center">OkWhen POS</h3>
</div>
<div class="flex-grid align-content-start justify-content-between hide-scrollbars ng-star-inserted" style="overflow-y: scroll; height: calc(100vh - 50px)">
  <div cdkdrag="" class="cdk-drag flex-grid-tile ng-star-inserted" style="width: 200px; height: 180px; background-color: rgb(0, 0, 0); color: rgb(255, 255, 255);" ng-reflect-data="[object Object]">
    <div class="cursor-move" style="color: rgb(203, 214, 226); line-height: 0.3; margin: 0px auto; white-space: pre-wrap; font-size: 18px; word-break: normal;">
      <br></div>
    <div class="flex-grid-tile-icon">
      <div class="widget-icon" style="font-size: 70px;">
        <i class="fas fa-store"></i></div>
    </div>
    <div class="flex-grid-tile-label"><span><div style="font-size: 0.9rem; font-weight: 400; text-align: left; color: rgb(255, 255, 255);">Merchandise</div></span>
    </div>
  </div>
  <div cdkdrag="" class="cdk-drag flex-grid-tile ng-star-inserted" style="width: 200px; height: 180px; background-color: rgb(0, 0, 0); color: rgb(255, 255, 255);" ng-reflect-data="[object Object]">
    <div class="cursor-move" style="color: rgb(203, 214, 226); line-height: 0.3; margin: 0px auto; white-space: pre-wrap; font-size: 18px; word-break: normal;">
      <br></div>
    <div class="flex-grid-tile-icon">
      <div class="widget-icon" style="font-size: 70px;">
        <i class="fas fa-user-plus"></i></div>
    </div>
    <div class="flex-grid-tile-label"><span><div style="font-size: 0.9rem; font-weight: 400; text-align: left; color: rgb(255, 255, 255);">Attendee Additions</div></span>
    </div>
  </div><!--container-->
  <div cdkdrag="" class="cdk-drag flex-grid-tile ng-star-inserted" style="width: 200px; height: 180px; background-color: rgb(0, 0, 0); color: rgb(255, 255, 255);" ng-reflect-data="[object Object]">
    <div class="cursor-move" style="color: rgb(203, 214, 226); line-height: 0.3; margin: 0px auto; white-space: pre-wrap; font-size: 18px; word-break: normal;">
      <br></div>
    <div class="flex-grid-tile-icon">
      <div class="widget-icon" style="font-size: 70px;">
        <i class="fas fa-ticket"></i></div>
    </div>
    <div class="flex-grid-tile-label"><span><div style="font-size: 0.9rem; font-weight: 400; text-align: left; color: rgb(255, 255, 255);">Verify Access</div></span>
    </div>
  </div><!--container-->


  <div (click)="showSettings()" class="cdk-drag flex-grid-tile ng-star-inserted" style="width: 200px; height: 180px; background-color: rgb(0, 0, 0); color: rgb(255, 255, 255);" ng-reflect-data="[object Object]">
    <div class="cursor-move" style="color: rgb(203, 214, 226); line-height: 0.3; margin: 0px auto; white-space: pre-wrap; font-size: 18px; word-break: normal;">
      <br></div>
    <div class="flex-grid-tile-icon">
      <div class="widget-icon" style="font-size: 70px;">
        <i class="fas fa-cog"></i></div>
    </div>
    <div class="flex-grid-tile-label"><span><div style="font-size: 0.9rem; font-weight: 400; text-align: left; color: rgb(255, 255, 255);">Settings</div></span>
    </div>
  </div><!--container-->


</div>
